<div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white shadow-lg rounded-lg p-8 max-w-md text-center">
        <h1 class="text-3xl font-bold text-blue-600 mb-4">Access Denied</h1>
        <p class="text-gray-700 mb-6">
            You are not authorized to access this application. Please log out and try again with proper credentials.
            or call Matwins support at Toll Free: 1 844-628-9467 (MAT-WINS). Local: +1 514-814-3798 or contact <a
                href="mailto:support&#64;matwins.com" class="text-blue-500">support&#64;matwins.com</a>.
        </p>
        <button (click)="authentificationService.logout()"
            class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded transition duration-200">
            Logout
        </button>
    </div>
</div>